import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

import { ContainedButton } from "common/DS/Buttons";
import COLOR from "lib/colors";
import { DSButtonProps } from "./types";

type Props = DSButtonProps & {
    loading: boolean;
    Component?: React.ComponentType<DSButtonProps>;
};

const LoadingButton = ({
    disabled,
    loading,
    children,
    Component = ContainedButton,
    ...props
}: Props) => (
    // If you're looking at me in the future, check to see if  MUI has finally released
    // this: https://mui.com/material-ui/react-button/#loading-button

    <Component disabled={loading || disabled} {...props}>
        {loading && (
            <>
                <CircularProgress
                    variant="indeterminate"
                    size={10}
                    sx={{ color: COLOR["slate-grey"] }}
                />
                &nbsp;
            </>
        )}
        {children}
    </Component>
);

export default React.memo(LoadingButton);
